export default __webpack_public_path__ + "static/media/yinhe.b8e76148.png";